import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Input, message } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import ListPanel from '@/components/ListPanel';
import Form from '@/components/Form';
import Tip from '@/components/Tip';
import { fetchFrontConfig, setFrontConfig } from '@/slices/platformSlice';
import Descriptions from '@/components/Descriptions';
import { updateDictByKey } from '@/services/dictService';
import ImageInput from './ImageInput';

const { FormItem } = Form;

function Config({ fetchFrontConfig, frontConfig, setFrontConfig }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetchFrontConfig();
  }, [fetchFrontConfig]);

  useEffect(() => {
    form.setFieldsValue(frontConfig);
  }, [frontConfig, form]);

  const resetFormItems = () => {
    form.setFieldsValue(frontConfig);
  };

  const handleSubmit = async (values) => {
    try {
      setSubmitting(true);
      const params = {
        ...values,
        version: dayjs().format('YYYYMMDDHHmmssSSS'),
      };
      await updateDictByKey({
        dictKey: 'front_config',
        dictValue: JSON.stringify(params),
      });
      setFrontConfig(params);
      message.success('保存成功');
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Root header='平台配置'>
      <Form form={form} labelWidth={140} onFinish={handleSubmit}>
        <Descriptions.Panel title='基本信息'>
          <FormItem label='平台名称' name='title' rules={[{ required: true }]}>
            <Input />
          </FormItem>

          <FormItem
            label={<Tip content='网站标签页小图标,64*64'>LOGO</Tip>}
            name='favico'
            rules={[{ required: true, message: '请上传网站标签页小图标' }]}
          >
            <ImageInput cropWidth={64} cropHeight={64} />
          </FormItem>

          <FormItem
            label={<Tip content='包含登录页和主页左上角图标,200*60'>头部LOGO</Tip>}
            name='head-logo'
            rules={[{ required: true, message: '请上传平台Logo' }]}
          >
            <ImageInput cropWidth={200} cropHeight={60} />
          </FormItem>
        </Descriptions.Panel>

        <Descriptions.Panel title='关于'>
          <FormItem label='隐藏关于页' name='about-hide' valuePropName='checked'>
            <Checkbox />
          </FormItem>

          <FormItem label='标题' name='about-title' rules={[{ required: true }]}>
            <Input />
          </FormItem>

          {/* <FormItem label='描述' name='about-description'>
            <Input />
          </FormItem> */}

          <FormItem
            label={<Tip content='关于页LOGO,80*80'>LOGO</Tip>}
            name='about-logo'
            rules={[{ required: true, message: '请上传关于页LOGO' }]}
          >
            <ImageInput cropWidth={80} cropHeight={80} />
          </FormItem>

          <FormItem
            label={<Tip content='《软件许可及服务协议》链接地址，不填写则不展示'>软件协议</Tip>}
            name='about-agreement'
          >
            <Input />
          </FormItem>

          <FormItem
            label={<Tip content='《隐私政策》链接地址，不填写则不展示'>隐私政策</Tip>}
            name='about-privacy-policy'
          >
            <Input />
          </FormItem>
        </Descriptions.Panel>

        <Descriptions.Panel title='第三方登录'>
          <FormItem label='认证地址' name='third-party'>
            <Input />
          </FormItem>

          <FormItem label='认证机构' name='third-party-org'>
            <Input />
          </FormItem>

          <FormItem
            label={
              <Tip
                content={
                  <>
                    隐藏后,系统会跳过登录页面，直接进入第三方登录
                    <br />
                    隐藏登录页：/superadmin-hlogin
                  </>
                }
              >
                隐藏平台登录
              </Tip>
            }
            name='hide-login'
            valuePropName='checked'
          >
            <Checkbox />
          </FormItem>
        </Descriptions.Panel>

        <Footer>
          <Button theme='default' variant='outline' onClick={resetFormItems}>
            重置
          </Button>
          <Button theme='primary' loading={submitting} variant='base' onClick={() => form.submit()}>
            保存
          </Button>
        </Footer>
      </Form>
    </Root>
  );
}

export default connect(
  (state) => ({
    frontConfig: state.platform.frontConfig,
  }),
  {
    fetchFrontConfig,
    setFrontConfig,
  },
)(Config);

const Root = styled(ListPanel)`
  .body-container {
    padding: 0 40px 20px;
  }
  .t-form {
    width: 700px;
  }
  .descriptions-title {
    padding-left: 20px;
    margin: 30px 0;
  }
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 140px;
  margin-top: 50px;
  gap: 20px;
`;
